export const requestStatesSimple = {
  rejected: {
    text: "requestRejected",
    color: "danger",
  },
} as const

export const requestStatesApprovable = {
  rejected: {
    text: "requestRejected",
    color: "danger",
  },
} as const

export const requestStates = {
  draft: {
    text: "requestDraft",
    color: "disabled",
  },
  underReview: {
    text: "requestReviewed",
    color: "warning",
  },
  approved: {
    text: "requestApproved",
    color: "success",
  },
  rejected: {
    text: "requestRevoked",
    color: "danger",
  },
  declined: {
    text: "requestRejected",
    color: "danger",
  },
  invitedPaidByDirectorate: {
    text: "requestApproved",
    color: "success",
  },
  invitedPaidByRegion: {
    text: "requestApproved",
    color: "success",
  },
  invitedWithoutCompensation: {
    text: "requestApproved",
    color: "success",
  },
  invitedWithoutServices: {
    text: "requestApproved",
    color: "success",
  },
  confirmedPaidByDirectorate: {
    text: "requestParticipationConfirmed",
    color: "success",
  },
  confirmedPaidByRegion: {
    text: "requestParticipationConfirmed",
    color: "success",
  },
  confirmedWithoutCompensation: {
    text: "requestParticipationConfirmed",
    color: "success",
  },
  confirmedWithoutTravel: {
    text: "requestReserved",
    color: "success",
  },
  confirmedWithoutServices: {
    text: "requestParticipationConfirmed",
    color: "success",
  },
  reserved: {
    text: "requestReserved",
    color: "success",
  },
  revoked: {
    text: "requestRevoked",
    color: "danger",
  },
  rejectedAfterConfirmation: {
    text: "requestRevoked",
    color: "danger",
  },
  confirmed: {
    text: "requestConfirmed",
    color: "success",
  },
  participated: {
    text: "requestConfirmed",
    color: "success",
  },
  didNotParticipate: {
    text: "requestNotConfirmed",
    color: "danger",
  },
  annulated: {
    text: "requestAnnulated",
    color: "danger",
  },
} as const

export const requestStatesForDetails: string[] = [
  "invitedPaidByDirectorate",
  "invitedPaidByRegion",
  "invitedWithoutCompensation",
  "invitedWithoutServices",
  "confirmedPaidByDirectorate",
  "confirmedPaidByRegion",
  "confirmedWithoutCompensation",
  "confirmedWithoutTravel",
  "confirmedWithoutServices",
  "participated",
]

export const requestStatesForTrip: string[] = [
  "confirmedPaidByDirectorate",
  "confirmedPaidByRegion",
  "confirmedWithoutCompensation",
  "confirmedWithoutServices",
  "participated",
]
